// extracted by mini-css-extract-plugin
export default {"chart":"DoughnutChart_chart__kcpP+"};